<template>
  <div id="topDualMediaCardRoot">
    <div id="container">
      <div id="mediaContainer">
        <div id="leftMediaContainer">
          <img class="leftMedia" v-if="image" :src="require('../../assets/' + image[0])" @contextmenu.prevent/>
          <video class="leftMedia" v-if="video" @contextmenu.prevent autoplay loop playsinline muted>
            <source :src="require('../../assets/' + video[0])" type="video/mp4"/>
          </video>
          <p  v-if="caption" class="caption" id="caption" v-html="secondaryCaption"></p>
        </div>
        <div id="rightMediaContainer">
          <img class="rightMedia" v-if="image" :src="require('../../assets/' + image[1])" @contextmenu.prevent/>
          <video class="rightMedia" v-if="video" @contextmenu.prevent autoplay loop playsinline muted>
            <source :src="require('../../assets/' + video[1])" type="video/mp4"/>
          </video>
          <p  v-if="secondaryCaption" id="secondaryCaption" class="caption" v-html="caption"></p>
        </div>
      </div>

      <div id="infoContainer">
        <p id="title" v-html="title"></p>
        <p id="description" v-html="description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopDualMediaCard",
  props: {
    height: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    secondaryCaption: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: ""
    },
    video: {
      type: Array,
    },
    image: {
      type: Array,
    },
  },
}
</script>

<style lang="scss" src="../../styles/blog/topdualmediacard.scss" scoped/>